import type { TCountry } from "../../types/outerLayout/common";

export type CityOption = { en: string; ar: string };

export const CITIES: Partial<Record<TCountry, CityOption[]>> = {
  EGY: [
    { en: 'Al Beheira', ar: 'البحيرة' },
    { en: 'Al Daqahliya', ar: 'الدقهلية' },
    { en: 'Al Fayoum', ar: 'الفيوم' },
    { en: 'Al Gharbia', ar: 'الغربية' },
    { en: 'Al Meniya', ar: 'المنيا' },
    { en: 'Al Monufia', ar: 'المنوفية' },
    { en: 'Al Sharqia', ar: 'الشرقية' },
    { en: 'Alexandria', ar: 'الإسكندرية' },
    { en: 'Aswan', ar: 'أسوان' },
    { en: 'Asyut', ar: 'أسيوط' },
    { en: 'Bani Souaif', ar: 'بني سويف' },
    { en: 'Cairo', ar: 'القاهرة' },
    { en: 'Damietta', ar: 'دمياط' },
    { en: 'Giza', ar: 'الجيزة' },
    { en: 'Ismailia', ar: 'الإسماعيلية' },
    { en: 'Kafr El-Sheikh', ar: 'كفر الشيخ' },
    { en: 'Luxor', ar: 'الأقصر' },
    { en: 'Marsa Matrooh', ar: 'مرسى مطروح' },
    { en: 'New Valley', ar: 'الوادي الجديد' },
    { en: 'Port Said', ar: 'بورسعيد' },
    { en: 'Qalyubia', ar: 'القليوبية' },
    { en: 'Qena', ar: 'قنا' },
    { en: 'Red Sea', ar: 'البحر الأحمر' },
    { en: 'Sohag', ar: 'سوهاج' },
    { en: 'South Sinai', ar: 'جنوب سيناء' },
    { en: 'Suez', ar: 'السويس' },
  ],
  OMN: [
    { en: 'Adam', ar: 'ادم' },
    { en: 'Al Ashkharah', ar: 'الشحراء' },
    { en: 'Al Buraimi', ar: 'البريمي' },
    { en: 'Al Hamra', ar: 'الحمراء' },
    { en: 'Al Jazer', ar: 'الجازر' },
    { en: "Al Madina A'Zarqa (Blue City)", ar: 'المدينة الزرقاء' },
    { en: 'Al Suwaiq', ar: 'السويق' },
    { en: 'As Sib (Seeb)', ar: 'السيب' },
    { en: 'Bahla', ar: 'بهلاء' },
    { en: 'Barka', ar: 'بركاء' },
    { en: 'Bidbid', ar: 'بدبد' },
    { en: 'Bidiya', ar: 'بدية' },
    { en: 'Duqm', ar: 'دقم' },
    { en: 'Haima', ar: 'هيماء' },
    { en: 'Ibra', ar: 'إبراء' },
    { en: 'Ibri', ar: 'عبري' },
    { en: 'Izki', ar: 'إزكي' },
    { en: 'Jabrin', ar: 'جبرين' },
    { en: 'Jalan Bani Bu Hassan', ar: 'جعلان بني بو حسن' },
    { en: 'Khasab', ar: 'خصب' },
    { en: 'Liwa', ar: 'لوى' },
    { en: 'Manah', ar: 'منح' },
    { en: 'Masirah', ar: 'مصيرة' },
    { en: 'Mudhaybi', ar: 'المضيبي' },
    { en: 'Mudhaireb', ar: 'المضيرب' },
    { en: 'Muscat', ar: 'مسقط' },
    { en: 'Muttrah', ar: 'مطرح' },
    { en: 'Nizwa', ar: 'نزوى' },
    { en: 'Quriyat', ar: 'قريات' },
    { en: 'Raysut', ar: 'ريسوت' },
    { en: 'Rustaq', ar: 'رستاق' },
    { en: 'Ruwi', ar: 'روي' },
    { en: 'Saham', ar: 'صحار' },
    { en: 'Saiq', ar: 'سيق' },
    { en: 'Salalah', ar: 'صلالة' },
    { en: 'Samail', ar: 'سمائل' },
    { en: 'Shinas', ar: 'شناص' },
    { en: 'Sohar', ar: 'صحار' },
    { en: 'Sur', ar: 'صور' },
    { en: "Tan'am", ar: "تنعم" },
    { en: 'Thumrait', ar: 'ثمريت' },
  ],
  SAU: [
    { en: 'Riyadh', ar: 'الرياض' },
    { en: 'Jeddah', ar: 'جدة' },
    { en: 'Mecca', ar: 'مكة المكرمة' },
    { en: 'Medina', ar: 'المدينة المنورة' },
    { en: 'Dammam', ar: 'الدمام' },
    { en: 'Taif', ar: 'الطائف' },
    { en: 'Tabuk', ar: 'تبوك' },
    { en: 'Buraydah', ar: 'بريدة' },
    { en: 'Khamis Mushait', ar: 'خميس مشيط' },
    { en: 'Al Hufuf (Al-Ahsa)', ar: 'الأحساء' },
    { en: 'Al Mubarraz', ar: 'المبرز' },
    { en: 'Hail', ar: 'حائل' },
    { en: 'Najran', ar: 'نجران' },
    { en: 'Al Jubail', ar: 'الجبيل' },
    { en: 'Abha', ar: 'أبها' },
    { en: 'Yanbu', ar: 'ينبع' },
    { en: 'Al Khobar', ar: 'الخبر' },
    { en: 'Dhahran', ar: 'الظهران' },
    { en: 'Al Qatif', ar: 'القطيف' },
    { en: 'Sakaka', ar: 'سكاكا' },
    { en: 'Arar', ar: 'عرعر' },
    { en: 'Jizan (Jazan)', ar: 'جازان' },
    { en: 'Al Bahah', ar: 'الباحة' },
    { en: 'Unayzah', ar: 'عنيزة' },
    { en: 'Rafha', ar: 'رفحاء' },
    { en: 'Al-Ula', ar: 'العلا' },
    { en: "Al Bad'", ar: 'البدع' },
    { en: 'Duba', ar: 'ضباء' },
    { en: 'Haql', ar: 'حقل' },
    { en: 'Hegra', ar: 'الحجر' },
    { en: 'Magna', ar: 'معينة' },
    { en: "Rijal Alma'a", ar: 'رجال المع' },
    { en: 'Ash Shafa', ar: 'الشفا' },
    { en: 'Alhada', ar: 'الحدا' },
    { en: 'Muzdalifah', ar: 'مزدلفة' },
    { en: "Qal'at Bishah", ar: 'قلعة بيشة' },
    { en: 'Sharurah', ar: 'شرورة' },
    { en: 'Wadi ad-Dawasir', ar: 'وادي الدواسر' },
    { en: 'Al Kharj', ar: 'الخرج' },
    { en: 'Az Zulfi', ar: 'الزلفي' },
    { en: 'Dawadmi', ar: 'الدوادمي' },
    { en: 'Afif', ar: 'عفيف' },
    { en: "Al Quway'iyah", ar: 'القويعية' },
    { en: 'Shaqra', ar: 'شقراء' },
    { en: "Al Majma'ah", ar: 'المجمعة' },
    { en: 'Rumah', ar: 'رماح' },
    { en: 'Al Ghat', ar: 'الغاط' },
    { en: 'Baljurashi', ar: 'بلجرشي' },
    { en: 'Al Namas', ar: 'النماص' },
    { en: 'Muhayil Asir', ar: 'محايل عسير' },
    { en: 'Sabya', ar: 'صبياء' },
    { en: 'Abu Arish', ar: 'أبو عريش' },
    { en: 'Al Wajh', ar: 'الوجه' },
    { en: 'Tayma', ar: 'تيماء' },
    { en: 'Khaybar', ar: 'خيبر' },
    { en: 'Badr', ar: 'بدر' },
    { en: 'Rabigh', ar: 'رابغ' },
  ],
  PAK: [
    { en: 'Punjab', ar: 'البنجاب' },
    { en: 'Lahore', ar: 'لاهور' },
    { en: 'Faisalabad', ar: 'فيصل آباد' },
    { en: 'Gujranwala', ar: 'غوجرانوالا' },
    { en: 'Rawalpindi', ar: 'راولبندي' },
    { en: 'Multan', ar: 'ملتان' },
    { en: 'Sialkot', ar: 'سيالكوت' },
    { en: 'Bahawalpur', ar: 'بهاولبور' },
    { en: 'Gujrat', ar: 'جوجرات' },
    { en: 'Sheikhupura', ar: 'شيخوبورا' },
    { en: 'Jhang', ar: 'جهانغ' },
    { en: 'Rahim Yar Khan', ar: 'رحيم يار خان' },
    { en: 'Sargodha', ar: 'سارجودها' },
    { en: 'Sahiwal', ar: 'ساهيوال' },
    { en: 'Okara', ar: 'أوكارا' },
    { en: 'Kasur', ar: 'قصور' },
    { en: 'Chiniot', ar: 'تشينيوت' },
    { en: 'Hafizabad', ar: 'حافظ آباد' },
    { en: 'Mandi Bahauddin', ar: 'ماندي بهاء الدين' },
    { en: 'Jhelum', ar: 'جلم' },
    { en: 'Narowal', ar: 'نارووال' },
    { en: 'Pakpattan', ar: 'باكباتان' },
    { en: 'Khushab', ar: 'خوشاب' },
    { en: 'Bhakkar', ar: 'بهككر' },
    { en: 'Layyah', ar: 'ليا' },
    { en: 'Muzaffargarh', ar: 'مظفر غار' },
    { en: 'Lodhran', ar: 'لودهران' },
    { en: 'Vehari', ar: 'وهاري' },
    { en: 'Bahawalnagar', ar: 'بهاولنغر' },
    { en: 'Khanewal', ar: 'خانيوال' },
    { en: 'Toba Tek Singh', ar: 'توبا تيك سنغ' },
    { en: 'Nankana Sahib', ar: 'ننكانا صاحب' },
    { en: 'Chakwal', ar: 'تشاكوال' },
    { en: 'Attock', ar: 'أتوك' },
    { en: 'Mianwali', ar: 'ميانوالي' },
    { en: 'Leiah', ar: 'ليا' },
    { en: 'Dera Ghazi Khan', ar: 'ديرا غازي خان' },
    { en: 'Rajanpur', ar: 'راجانبور' },
    { en: 'Sindh', ar: 'السند' },
    { en: 'Karachi', ar: 'كراتشي' },
    { en: 'Hyderabad', ar: 'حيدر آباد' },
    { en: 'Sukkur', ar: 'سككر' },
    { en: 'Larkana', ar: 'لاركانا' },
    { en: 'Mirpur Khas', ar: 'ميربور خاص' },
    { en: 'Nawabshah (Shaheed Benazirabad)', ar: 'نوابشاه' },
    { en: 'Jacobabad', ar: 'يعقوب آباد' },
    { en: 'Shikarpur', ar: 'شيكاربور' },
    { en: 'Khairpur', ar: 'خيربور' },
    { en: 'Dadu', ar: 'دادو' },
    { en: 'Sanghar', ar: 'سانغهار' },
    { en: 'Umerkot', ar: 'أميركوت' },
    { en: 'Mithi (Tharparkar)', ar: 'ميثي' },
    { en: 'Badin', ar: 'بادين' },
    { en: 'Thatta', ar: 'تهتا' },
    { en: 'Kashmore', ar: 'كشمور' },
    { en: 'Ghotki', ar: 'غوتكي' },
    { en: 'Matiari', ar: 'ماتياري' },
    { en: 'Tando Muhammad Khan', ar: 'تاندو محمد خان' },
    { en: 'Tando Allahyar', ar: 'تاندو الله يار' },
    { en: 'Jamshoro', ar: 'جامشورو' },
    { en: 'Khyber Pakhtunkhwa', ar: 'خيبر بختونخوا' },
    { en: 'Peshawar', ar: 'بيشاور' },
    { en: 'Mardan', ar: 'مردان' },
    { en: 'Mingora (Swat)', ar: 'مينغورا' },
    { en: 'Abbottabad', ar: 'أبوت آباد' },
    { en: 'Mansehra', ar: 'مانسهرا' },
    { en: 'Kohat', ar: 'كوهات' },
    { en: 'Bannu', ar: 'بانو' },
    { en: 'Dera Ismail Khan', ar: 'ديرا إسماعيل خان' },
    { en: 'Nowshera', ar: 'نوشهرا' },
    { en: 'Charsadda', ar: 'تشارسدا' },
    { en: 'Swabi', ar: 'صوابي' },
    { en: 'Haripur', ar: 'هاريبور' },
    { en: 'Battagram', ar: 'باتغرام' },
    { en: 'Balochistan', ar: 'بلوشستان' },
    { en: 'Quetta', ar: 'كويتا' },
    { en: 'Turbat', ar: 'تركبات' },
    { en: 'Khuzdar', ar: 'خضدار' },
    { en: 'Hub', ar: 'هاب' },
    { en: 'Chaman', ar: 'شامان' },
    { en: 'Zhob', ar: 'ژوب' },
    { en: 'Gwadar', ar: 'جوادر' },
    { en: 'Mastung', ar: 'مستونغ' },
    { en: 'Loralai', ar: 'لورالاي' },
    { en: 'Pishin', ar: 'بيشين' },
    { en: 'Kharan', ar: 'خاران' },
    { en: 'Dera Bugti', ar: 'ديرا باغتي' },
    { en: 'Nushki', ar: 'نوشكي' },
    { en: 'Kalat', ar: 'قلات' },
    { en: 'Harnai', ar: 'هرنائي' },
    { en: 'Jaffarabad', ar: 'جعفر آباد' },
    { en: 'Jhal Magsi', ar: 'جهل ماغسي' },
    { en: 'Islamabad Capital Territory', ar: 'إسلام آباد' },
    { en: 'Islamabad', ar: 'إسلام آباد' },
    { en: 'Azad Kashmir', ar: 'آزاد كشمير' },
    { en: 'Muzaffarabad', ar: 'مظفر آباد' },
    { en: 'Mirpur', ar: 'ميربور' },
    { en: 'Gilgit-Baltistan', ar: 'غلغت-بلتستان' },
    { en: 'Gilgit', ar: 'غلغت' },
    { en: 'Skardu', ar: 'سكاردو' },
  ],
  ARE: [
    { en: 'Al Ayn', ar: 'العين' },
    { en: 'Madinat Zayid', ar: 'مدينة زايد' },
    { en: 'Shariyah', ar: 'الشارقة' },
    { en: 'Maufut', ar: 'مصفوت' },
    { en: 'Sufayri', ar: 'الصفيري' },
    { en: 'Zubarah', ar: 'الزبارة' },
    { en: 'Bitnah', ar: 'بتنة' },
    { en: 'Mutaridah', ar: 'المطاردة' },
    { en: 'Theeb', ar: 'الذيب' },
    { en: 'Wabayn', ar: 'وبين' },
    { en: 'Al Qurayyah', ar: 'القريّة' },
    { en: 'Al Manamah', ar: 'المنامة' },
    { en: "'Abadilah", ar: 'العبادلة' },
    { en: 'Al Halah', ar: 'الحلة' },
    { en: 'Ghurfah', ar: 'الغرفة' },
    { en: 'Hayl', ar: 'حيل' },
    { en: 'Al Fuqait', ar: 'الفقع' },
    { en: 'Saif', ar: 'سيف' },
    { en: 'Badiyah', ar: 'البدية' },
    { en: 'Farah', ar: 'فرح' },
    { en: 'Mukhtaraqah', ar: 'مختارقة' },
    { en: 'Yalah', ar: 'يالة' },
    { en: 'Ţayyibah', ar: 'الطيبة' },
    { en: 'Harat Zutut', ar: 'حارة زتوت' },
    { en: 'Al Uyaynah', ar: 'العيينة' },
    { en: 'Rul Dadna', ar: 'رول دادنا' },
    { en: 'Rughaylat', ar: 'رغيلات' },
    { en: 'Tawian', ar: 'طويان' },
    { en: 'Shawiyah', ar: 'الشاوية' },
    { en: 'Diba', ar: 'دبا' },
    { en: 'Sinnah', ar: 'السنّة' },
    { en: 'Riyamah', ar: 'الريامة' },
    { en: 'Dub', ar: 'دب' },
    { en: 'Sram', ar: 'صرام' },
    { en: 'Thoban', ar: 'ثوبان' },
    { en: 'Hafarah', ar: 'الحفرة' },
    { en: 'Al Gissemari', ar: 'القيصمارية' },
    { en: 'Khulaybīyah', ar: 'الخليبية' },
    { en: 'Zanhah', ar: 'زنحة' },
    { en: 'Saqamqam', ar: 'صقمقم' },
    { en: 'Dahir', ar: 'الظاهر' },
    { en: 'Jareef', ar: 'الجريف' },
    { en: 'Al Kubus', ar: 'القبوس' },
    { en: 'Ashashah', ar: 'العشاشة' },
    { en: 'Aqqah', ar: 'عقة' },
    { en: 'Ras Dibba', ar: 'رأس دبا' },
    { en: 'Murbad', ar: 'مربد' },
    { en: 'Safad', ar: 'صفد' },
    { en: 'Tariqat Jad', ar: 'طريقة جديدة' },
    { en: 'Tarif Kalba', ar: 'طريف كلباء' },
    { en: "Ud al Bayda'", ar: 'عد البيضاء' },
    { en: 'Qaraytaysah', ar: 'قريةيسة' },
    { en: 'Margham', ar: 'مرغم' },
    { en: 'Qimah', ar: 'القيمة' },
    { en: 'Hunaywah', ar: 'هنيفة' },
    { en: 'Urqub Juwayza', ar: 'عرقوب جويزة' },
    { en: 'Ferij al Muhadham', ar: 'فريج المحضم' },
    { en: 'Al Faq', ar: 'الفق' },
    { en: 'Hatta', ar: 'حتا' },
    { en: 'Al Lusayli', ar: 'اللوسيلي' },
    { en: 'Warisan', ar: 'ورسان' },
    { en: 'Asamah', ar: 'العصمة' },
    { en: 'Al Ayn al Ghumur', ar: 'العين الغمر' },
    { en: 'Wahlah', ar: 'وهلة' },
    { en: 'Siji', ar: 'سيجي' },
    { en: 'Dabaah', ar: 'دباء' },
    { en: 'Mawrid', ar: 'موريد' },
    { en: 'Hasat al Bidiyah', ar: 'حصة البيدية' },
    { en: 'Mudayfi', ar: 'المديفي' },
    { en: 'Lulayyah', ar: 'اللولية' },
    { en: 'Al Jazirah', ar: 'الجزيرة' },
    { en: 'Wadi Shi', ar: 'وادي شي' },
    { en: 'Khawr Fakkan', ar: 'خور فكان' },
    { en: 'Ash Shuaayb', ar: 'الشعيبة' },
    { en: 'Hiyawah', ar: 'هياوة' },
    { en: 'Ar Rufaysah', ar: 'الرفيسة' },
    { en: "Rafa'", ar: 'رفع' },
    { en: 'Shis', ar: 'شيس' },
    { en: 'Nahwah', ar: 'نهوة' },
    { en: 'Al Hamriyah', ar: 'الحمرية' },
    { en: 'Adh Dhayd', ar: 'الذيد' },
    { en: 'Al Awdah', ar: 'العودة' },
    { en: 'Qidfaa', ar: 'قدفاء' },
    { en: 'Uqayr', ar: 'عقير' },
    { en: 'Ghayl', ar: 'غيل' },
    { en: 'Khawr Kalba', ar: 'خور كلباء' },
    { en: 'Murbah', ar: 'مربة' },
    { en: 'Harrah', ar: 'حرة' },
    { en: 'Kalba', ar: 'كلباء' },
    { en: 'Hayat', ar: 'حيات' },
    { en: 'Girath', ar: 'جراث' },
    { en: 'Nuhayy', ar: 'نهي' },
    { en: 'Umm al Qaywayn', ar: 'أم القيوين' },
  ],
} as const;
